module.exports = __webpack_public_path__ + "aud_icon.svg?dacc942534d43bbc7e8b52fa5010a786";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/aud_icon.svg
// module id = 1134
// module chunks = 2